import { render, staticRenderFns } from "./EditorCodigo.vue?vue&type=template&id=46a1301c&scoped=true"
import script from "./EditorCodigo.vue?vue&type=script&lang=js"
export * from "./EditorCodigo.vue?vue&type=script&lang=js"
import style0 from "./EditorCodigo.vue?vue&type=style&index=0&id=46a1301c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a1301c",
  null
  
)

export default component.exports